module.exports = __webpack_public_path__ + "static/media/spinner.482f7152.gif";